import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorList } from '@guildeducationinc/recess';
import ExpandLessIcon from '@guildeducationinc/recess/icons/ExpandLessIcon';
import ExpandMoreIcon from '@guildeducationinc/recess/icons/ExpandMoreIcon';
import { Button, Menu, MenuItem } from '@mui/material';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import { useMemo, useRef, useState } from 'react';
import { useLocale } from '../../hooks';
import styles from './DropdownSelect.module.scss';
export const DropdownSelect = ({ label, value, onChange, options, className, btnClass, btnStyle, errors, disabled, color = 'secondary', variant = 'text', hideLabel, showCaret = true, isClearable = true, }) => {
    const { t } = useLocale();
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const btnId = useRef(uniqueId('dropdown-select'));
    const menuId = useRef(uniqueId('dropdown-select-menu'));
    const selectedItem = useMemo(() => options.find(opt => opt.value === value), [options, value]);
    const handleSelect = (item) => {
        const value = isClearable && selectedItem?.value === item.value ? undefined : item.value;
        // Trigger onChange event
        onChange({
            target: { value },
            selection: { value },
        });
        handleClose();
    };
    return (_jsxs("div", { className: className, children: [_jsx(Button, { className: classNames(styles.btn, btnClass), style: btnStyle || { padding: '12px' }, color: color, id: btnId.current, "aria-controls": isOpen ? menuId.current : undefined, "aria-haspopup": 'true', "aria-expanded": isOpen ? 'true' : undefined, onClick: handleClick, disabled: disabled, variant: variant, endIcon: !disabled && showCaret ? (isOpen ? (_jsx(ExpandLessIcon, { size: 20 })) : (_jsx(ExpandMoreIcon, { size: 20 }))) : undefined, children: selectedItem?.displayText ||
                    selectedItem?.label ||
                    (!hideLabel && (label || t('Select an option'))) || _jsx(_Fragment, { children: "\u00A0" }) }), _jsxs(Menu, { disablePortal: true, id: menuId.current, anchorEl: anchorEl, open: isOpen, onClose: handleClose, MenuListProps: { 'aria-labelledby': btnId.current }, anchorOrigin: { vertical: 'top', horizontal: 'right' }, children: [options.map(opt => (_jsx(MenuItem, { selected: opt.value === value, onClick: () => handleSelect(opt), disabled: opt.disabled, children: opt.label }, opt.value))), options.length === 0 && _jsx(MenuItem, { disabled: true, children: "No options" })] }), _jsx(ErrorList, { show: !!errors, errors: errors })] }));
};
